import React from 'react';
import Navbar from '../components/Navbar';
import PulseboardPanel from '../components/pulseboard/Pulseboard';

const Pulseboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pb-16">
        <PulseboardPanel />
      </div>
    </div>
  );
};

export default Pulseboard;
